import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';

const DeleteAccount = () => {
    const [email, setEmail] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(true);

    useEffect(() => {
        document.title = "Always Outdoors | Delete Account";
        // eslint-disable-next-line
    }, [window.location.pathname])


    const handleEmailChange = (event) => {
        setEmail(event.target.value);
        setIsValidEmail(true);
    };



    const handleDeleteClick = () => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success mx-2',
                cancelButton: 'btn btn-danger mx-2',
            },
            buttonsStyling: false,
        });

        swalWithBootstrapButtons
            .fire({
                title: 'Are you sure?',
                text: "You want to delete this account",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                reverseButtons: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    swalWithBootstrapButtons.fire({
                        title: 'Deleted!',
                        text: 'Your account has been deleted.',
                        icon: 'success',
                    });
                    setEmail('');
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    swalWithBootstrapButtons.fire({
                        title: 'Cancelled',
                        text: 'Your account is safe.',
                        icon: 'error',
                    });
                }
            });
    };
    return (
        <section>
            <div className="section-after">
                <div className='container'>
                    <div className="my-5 py-5 row justify-content-center">
                        <div className='col-6'>
                            <div className="card shadow-lg rounded-3 border-0">
                                <div className="border-bottom p-3">
                                    <h3 className="text-center">Account Deletion</h3>
                                </div>

                                <div className="card-body" id="CardBody">
                                    <p className="card-text text-muted fw-semibold w-100">
                                        We appreciate your engagement with Always Outdoors and are sorry to hear that you're considering deleting your account. Please note that if you choose to delete your account, the process will take approximately 24 working hours to complete. During this period, your account information will be securely processed and removed from our systems. After the deletion is complete, you are welcome to recreate your account and rejoin the Always Outdoors community at any time. We value your presence and hope you reconsider, but if you decide to proceed with the account deletion, we wish you the best and hope to welcome you back in the future.
                                        {/* shortened for brevity */}
                                    </p>
                                    <form className="row g-3 needs-validation" noValidate>
                                        <div className="col-md-12 pt-3">
                                            <input
                                                type="email"
                                                className={`form-control ${!isValidEmail ? 'is-invalid' : ''}`}
                                                id="validationCustom03"
                                                placeholder="Enter your email"
                                                required
                                                value={email}
                                                onChange={handleEmailChange}
                                            />
                                            <div className="invalid-feedback">
                                                Please provide a valid email.
                                            </div>
                                        </div>
                                        <p className="card-text text-danger fw-bolder w-100">
                                            <i className="fa-solid fa-triangle-exclamation fs-5 pe-2"></i>
                                            Note* : The process will take approximately 24 working hours to complete.
                                        </p>
                                        <div className="col-12 d-flex justify-content-end ">
                                            <button
                                                className="btn btn-danger"
                                                type="button"

                                                onClick={handleDeleteClick}
                                            >
                                                Delete My Account
                                            </button>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DeleteAccount
